import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Holder = styled.div.attrs({
  className: 'column',
})`
  position: relative;
  @media( ${props => props.theme.breakpoints.lg} ) {
    grid-column: ${props => props.columns};
  }
  .rich-text-holder {
    @media( ${props => props.theme.breakpoints.md} ) {
      padding: ${props => props.hasPadding ? '6rem 2rem' : '0'};
    }
    .gatsby-image-wrapper {
      margin: 4rem 0;
      @media( ${props => props.theme.breakpoints.md} ) {
        margin: 6rem 0;
      }
      + .gatsby-image-wrapper {
        @media(${props => props.theme.breakpoints.lg}) {
          transform: translateX(-16.6%);
        }
      }
      &:nth-last-child(2) {
        margin-bottom: 0;
      }
    }
    > :first-child { margin-top: 0; }
    > :last-child { margin-bottom: 0; }
    > p:first-child {
      @media( ${props => props.theme.breakpoints.xl} ) {
        margin-top: 3rem;
      }
    }
    > h2:first-child {
      @media( ${props => props.theme.breakpoints.xl} ) {
        margin-top: 4rem;
      }
    }
  }
  .cta-holder {
    margin-top: 0;
  }
  .button {
    margin-top: 2rem;
    @media( ${props => props.theme.breakpoints.md} ) {
      margin-top: 3rem;
    }
  }
`;

function Column({children, width, hasPadding}) {
    return (
      <Holder columns={width} hasPadding={hasPadding}>{children}</Holder>
    )
}

Column.propTypes = {
  width: PropTypes.string,
  hasPadding: PropTypes.bool,
};

Column.defaultProps = {
  width: 'span 6',
  hasPadding: false,
};

export default Column;
